"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyLinkInputButton = void 0;
var UserActionEvent = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _esToolkit = require("es-toolkit");
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Component for copying a link to the clipboard.
 * @param {CopyLinkInputButtonProps} props - The props for the component.
 * @returns {JSX.Element}
 */
const CopyLinkInputButton = ({
  link,
  buttonText,
  copiedText,
  className,
  fullWidth,
  backgroundGradientColors,
  ariaLabels: ariaLabelsParam,
  onCopy
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onClose,
    onOpen,
    open: copied
  } = (0, _presentationHooks.useDisclose)();
  const ariaLabels = (0, _react.useMemo)(() => ariaLabelsParam ? (0, _esToolkit.merge)(_constants.DEFAULT_ARIA_LABELS, ariaLabelsParam) : _constants.DEFAULT_ARIA_LABELS, [ariaLabelsParam]);
  const handleCopyClick = (0, _react.useCallback)(async () => {
    if (link.includes(_constants.SHARED_LIST)) {
      UserActionEvent.dispatch([_constants.FAVORITES_LIST_SHARE, window.location.pathname]);
    }
    await navigator.clipboard.writeText(link);
    onOpen();
    onCopy?.();
    setTimeout(() => {
      onClose();
    }, 1500);
  }, [link, onClose, onCopy, onOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.COPY_LINK_INPUT_WITH_BUTTON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      open: copied,
      placement: "top",
      title: copiedText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CopyLinkButton, {
        backgroundGradientColors: backgroundGradientColors,
        buttonContent: copied ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {
          "aria-label": ariaLabels.copiedButton
        }) : buttonText,
        component: "div",
        role: "group",
        fullWidth: fullWidth,
        "aria-label": ariaLabels.copyButton,
        "aria-describedby": "link-display",
        onClick: handleCopyClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkContent, {
          id: "link-display",
          children: link
        })
      })
    })
  });
};
exports.CopyLinkInputButton = CopyLinkInputButton;
//# sourceMappingURL=CopyLinkInputWithButton.js.map